import React, {useRef} from "react";
import Table from "../Table/Table";
import {Col, Spinner} from "react-bootstrap";
import {snakeCaseToNormalString} from "../../General/SharedMethods";

export default function CuWaterSystemsTable(props) {
    const headerStyle = {fontSize: 14};
    const wideHeaderStyle = {minWidth: 230, fontSize: 14};
    const colStyle = {minWidth: 100, fontSize: 14, whiteSpace: 'nowrap'};
    const filtersRefs = useRef([]);
    const nameFilterRef = useRef();
    const typeFilterRef = useRef();

    const resetFilters = () => {
        filtersRefs.current.forEach(currFilter => {
            if (currFilter) currFilter('');
        })
        nameFilterRef.current?.resetFilter();
        typeFilterRef.current?.resetFilter();
    }

    const columns = [
        {dataField: 'id', text: 'ID', headerStyle: headerStyle, style: colStyle, editable: false},
        {
            dataField: 'name',
            text: 'Name',
            headerStyle: wideHeaderStyle,
            formatter: props.waterSystemNameFormatter,
            style: colStyle,
            editable: false
        },
        {
            dataField: 'type',
            text: 'Type',
            headerStyle: headerStyle,
            style: colStyle,
            editable: false,
            formatter: snakeCaseToNormalString
        },
        {dataField: 'productId', text: 'Product ID', headerStyle: headerStyle, style: colStyle, editable: false},
        {editable: false, formatter: props.waterSystemDeleteFormatter},
    ]
    if (!props || (props.data?.length === 0) && !props.isNoWaterSystems || props.isUpdateDetailsRequestInProgress && !props.isApplyingActive) {
        return (<Col md={{offset: 5, span: 1}}><Spinner animation="border" variant="primary"/></Col>)
    } else {
        return (<div style={{overflowX: 'hidden', overflowY: 'auto', height: props.tableHeight}}>
            <Table
                isHeadersSticky={!props.tableHeight}
                data={props.data}
                columns={columns}
                disablePagination
                pageSize={15}
                resetFilters={resetFilters}/>
        </div>)
    }
}
